import React, { useEffect, useState } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import { Container, Row, Col, Table, Button } from "react-bootstrap";
import ThemeTable from "../component/ThemeTable";
import Loader from "../component/Loader";
import { useNavigate } from "react-router-dom";
import OtherService from "../services/Other";
import ModalComponent from "../component/ModalComponent";
import toast from "react-hot-toast";
import SelectDropDown from "../component/SelectDropDown";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import PrimaryOutLineButton from "../component/PrimaryOutLineButton";
import NoData from "../component/NoData";

const MyService = () => {
    
  const allStatus = [
    { id: "pending", title: "Pending", pageNo: 1 },
    { id: "accepted", title: "Approved / Rejected", pageNo: 1 },
  ];
  const [loading, setLoading] = useState(true);
  const [myServiceData, setMyServiceData] = useState([]);
  const [currentServiceData, setCurrentServiceData] = useState([]);
  const [serviceRejectReasonData, setServiceRejectReasonData] = useState([]);
  const [serviceAcceptReasonData, setServiceAcceptReasonData] = useState([]);
  const [selectedValue, setSelectedValue] = useState({
    id: "",
    title: "",
  });
  const userInfo = JSON.parse(localStorage.getItem("userData") || "{}");
  const isHierDesc = userInfo?.description || null;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isRejectReasonShow, setIsRejectReasonShow] = useState(false);
  const [isAcceptReasonShow, setIsAcceptReasonShow] = useState(false);
  // const [serviceRejectReason, setServiceRejectReason] = useState('');
  const [evenCounter, setEvenCounter] = useState(0);
  const [showAlert, setShowAlert] = useState(false); // show success or error message on modal
  const [isLoginSuccessCondition, setIsLoginSuccessCondition] = useState("");
  const [isLoginSuccessText, setIsLoginSuccessText] = useState("");
  const [isLoginSuccessHeading, setIsLoginSuccessHeading] = useState("");
  const [showMore, setShowMore] = useState(true);
  const [status, setStatus] = useState(allStatus[0]);
  const [allMarked, setAllMarked] = useState([]);
  const [allMItems, setAllMItems] = useState([]);

  const handleShowModal = async (item) => {
    // setSelectedEvent(event);

    setCurrentServiceData(item);

    const dcm_hierarchies_id = item.hier_id; //userData.dcm_hierarchies_id;
    const myServiceRejectReasonsResponse =
      await OtherService.getServiceReasonList("reject", dcm_hierarchies_id);
    const myServiceAcceptReasonsResponse =
      await OtherService.getServiceReasonList("accept", dcm_hierarchies_id);

    const filteredData =
      myServiceRejectReasonsResponse.response.reasonsList.map((item, index) => {
        return {
          id: item.id,
          title: item.reasons,
        };
      });
    const filteredAcceptData =
      myServiceAcceptReasonsResponse.response.reasonsList.map((item, index) => {
        return {
          id: item.id,
          title: item.reasons,
        };
      });

    setServiceRejectReasonData(filteredData);
    setServiceAcceptReasonData(filteredAcceptData);
    // If ther is any message in modal then hide first
    setShowAlert(false);
    // Open the modal
    setIsModalOpen(true);
  };

  const handleRejectReasonOnChange = (selectedValue) => {
    setSelectedValue(selectedValue);
  };

  const handleApprove = async (accept_reject) => {
    var request = {
      service_id: parseInt(currentServiceData.service_id),
      contact_id_contractor: String(currentServiceData.contractor_contact_id),
      reasons: selectedValue.title,
      other_reason: "",
      accept_or_reject: accept_reject,
    };

    const token = localStorage.getItem("access_token");
    const acceptReject = await OtherService.serviceAcceptOrReject(request);
    if (acceptReject.response.serviceResult.status) {
      // alert(acceptReject.data.response.message);
      setShowAlert(true);
      setIsRejectReasonShow(false);
      setStatus(p => ({...p, pageNo: 1})) // this line is for refresh
      toast.success(acceptReject.response.serviceResult.message);
      // setIsLoginSuccessHeading(acceptReject.data.response.message);
      // setIsLoginSuccessText(acceptReject.data.response.serviceResult.message);
      setIsModalOpen(false);
      // if(acceptReject.data.response.serviceResult.status){
      //     setIsLoginSuccessCondition('successAlert')
      //     setTimeout(()=>{
      //         setEvenCounter(prevCounter => prevCounter + 1);
      //     },2000)
      // }
      // setIsModalOpen(false);
      // setEvenCounter(prevCounter => prevCounter + 1)
    } else {
      toast.error(acceptReject.response.serviceResult.message);
      // alert(acceptReject.message);
    }
  };

  //Format Date
  const formatDate = (date) => {
    const dateTime = new Date(date);
    return dateTime.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true,
    });
  };

  const myServiceDataFetch = async () => {
    try {
      setLoading(true)
      const myServiceDataFetchResponse = await OtherService.getServiceList(
        30,
        status.pageNo,
        status.id
      );
      setLoading(false)
      if (myServiceDataFetchResponse.response.serviceData.length == 0) {
        setShowMore(false);
        toast.error(status.pageNo == 1 ? "No services found" : "No more services");
        if(status.pageNo == 1) {
          setMyServiceData([]);
        }
        return;
      } else {
        setShowMore(true);
      }
      if (
        myServiceDataFetchResponse.success == true &&
        myServiceDataFetchResponse.response.serviceData.length > 0
      ) {
        const filteredData =
          myServiceDataFetchResponse.response.serviceData.map((item, index) => {
            let serialNo = <div className="text-center">{index + 1}</div>;
            //Status Check
            let statusElement;
            if (item.service_status == 0) {
              statusElement = (
                <div className="text-center">
                  {isHierDesc != "TSE" && (
                    <span className="pendingTxt m-140 d-inline-block">
                      Submitted For Approval
                    </span>
                  )}
                  {isHierDesc == "TSE" && (
                    <div className="pendingStatusBlock">
                      <span className="pendingTxt">Pending</span>
                      <button
                        className="checkNowBtn"
                        onClick={() => handleShowModal(item)}
                      >
                        Check
                      </button>
                    </div>
                  )}
                </div>
              );
            } else if (item.service_status == 1) {
              statusElement = (
                <div className="text-center approvedTxt">
                  <span
                    className={
                      isHierDesc == "TSE"
                        ? "w-100 approvedTxt d-inline-block"
                        : "m-150 approvedTxt d-inline-block"
                    }
                  >
                    Approved
                  </span>
                </div>
              );
            } else if (item.service_status == 2) {
              statusElement = (
                <div className="text-center rejectedTxt">
                  <span
                    className={
                      isHierDesc == "TSE"
                        ? "w-100 rejectedTxt d-inline-block"
                        : "m-150 rejectedTxt d-inline-block"
                    }
                  >
                    Rejected
                  </span>
                </div>
              );
            }
            if (isHierDesc != "TSE" && isHierDesc != null) {
              return {
                "Serial No": serialNo,
                "Service Id": item.service_id,
                "Service Date": formatDate(item.service_date),
                "Description": item.product_description,
                "Enrolled Date": formatDate(item.created_at),
                "Status": statusElement,
              };
            } else {
              return {
                "Select": {
                  isChecked: false,
                  serviceStatus: item.service_status,
                  item: item,
                },
                "Service Id": item.service_id,
                "Service Date": formatDate(item.service_date),
                "Description": item.product_description,
                "Enrolled Date": formatDate(item.created_at),
                "Status": statusElement,
              };
            }
          });
        if (filteredData.length == 0) {
          setShowMore(false);
          return;
        }
        
        if (status.pageNo == 1) setMyServiceData(filteredData);
        if (status.pageNo > 1) setMyServiceData((p) => [...p, ...filteredData]);
        setLoading(false);
      } else {
    
      }
    } catch (e) {
      // setLoading
      setLoading(false)
    } finally {
    }
  };
  useEffect(() => {
    myServiceDataFetch();
  }, [status]);

  function onLoadMore() {
    setStatus((p) => ({ ...p, pageNo: p.pageNo + 1 }));
  }
  let headers = [];
  if (myServiceData.length > 0) {
    headers = Object.keys(myServiceData[0]);
  }

  function onChecked(item) {

    if (allMarked.includes(item["Service Id"])) {
      const newList = allMItems.filter(
        (i) => i.service_id != item["Service Id"]
      );
      setAllMItems(newList);
      const list = allMarked.filter((i) => i != item["Service Id"]);
      setAllMarked(list);
    } else {
      if (allMarked.length > 14) {
        toast.error("Cannot approve more than 5 items");
        return;
      }
      setAllMarked((p) => [...p, item["Service Id"]]);
      setAllMItems((p) => [...p, { ...item.Select.item }]);
    }
    const updatedPList = myServiceData.map((service) => {
      if (service["Service Id"] === item["Service Id"]) {
        const { Select, ...rest } = service;
        return {
          Select: {
            isChecked: !allMarked.includes(item["Service Id"]),
            serviceStatus: item.Select.item.service_status,
            item: item.Select.item,
          },
          ...rest,
        };
      }
      return service;
    });

    setMyServiceData(updatedPList);
  }

  function submitHandler(item, idx, len, toastId) {
    if (loading) return;
    let payload = {
      accept_or_reject: "accept",
      contact_id_contractor: item.contractor_contact_id,
      other_reason: "",
      reasons: "Confirmed by Technical Services Officer",
      service_id: item.service_id,
    };
    OtherService.serviceAcceptOrReject(payload)
      .then((res) => {
        if (res.success) {
          if (res.response.serviceResult.status) {
            toast.success(`Service id ${item.service_id} approved successfully`);
          } else {
            toast.error(`Service id ${item.service_id} approval failed`);
        }
        } else {
            toast.error(`Service id ${item.service_id} approval failed`);
        }
      })
      .catch((err) => {
        toast.error(`Something went wrong`);
      }).finally(() => {
        if(len == idx) {
            toast.dismiss(toastId);
            setStatus(p => ({...p, pageNo: 1}))
            setAllMItems([]);
            setAllMarked([]);
        }
      });
  }

  function approveAll() {
    const toastId = toast.loading("Loading...");
    allMItems.forEach((item, index) => {
      submitHandler(item, index + 1, allMItems.length, toastId);
    });
  }

  function onHide() {
    setTimeout(() => {
      setIsAcceptReasonShow(false)
      setIsRejectReasonShow(false)
    }, 400)
  }

  return (
    <>
      {/* {loading && <Loader />} */}

      {isHierDesc != "TSE" && (
        <BreadCrumbSecttion
          pageTitle="My Service"
          currentPageName="My Service"
        />
      )}
      {isHierDesc == "TSE" && (
        <BreadCrumbSecttion
          pageTitle="Service Approval"
          currentPageName="Service Approval"
        />
      )}
      <section className="padTop50">
        {allMarked.length > 0 && (
          <Button className="float-footer" onClick={approveAll}>
            Approve All
          </Button>
        )}
        <Container>
          <Row>
            <Col xs={12} lg={12}>
              <div className="searchBoxBlock my-4">
                <Row>
                  <Col xs={12} lg={3}>
                    <SelectDropDown
                      labelName="Filter by status"
                      // requiredStar="*"
                      options={allStatus}
                      setSelectedValue={setStatus}
                      selectedValue={status}
                      // onChange={handleContentDistrictNameChange}
                      page="searchFilter"
                    />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              {myServiceData.length == 0 && !loading && <NoData /> }
              {myServiceData.length === 0 && loading && <NoData title="Fetching..." />}
              {myServiceData.length > 0 && <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    {headers.length > 0 &&
                      headers.map((header, index) => (
                        <th key={index}>{header}</th>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {myServiceData.length > 0 &&
                    myServiceData.map((item, index) => {

                      // const keysArray = Object.keys(item);
                      // return (
                      return (
                        <tr key={index}>
                          {isHierDesc == "TSE" ? (
                            <td>
                              <input
                                disabled={item?.Select?.serviceStatus != 0}
                                type="checkbox"
                                id="scales"
                                name="scales"
                                checked={item?.Select?.isChecked}
                                onChange={() => onChecked(item)}
                              />
                            </td>
                          ) : (
                            <td>{index + 1}</td>
                          )}
                          <td>
                            <div>{item["Service Id"]}</div>
                          </td>
                          <td>
                            <div>{item["Service Date"]}</div>
                          </td>
                          <td>
                            <div>{item["Description"]}</div>
                          </td>
                          <td>
                            <div>{item["Enrolled Date"]}</div>
                          </td>
                          <td>
                            <div>{item["Status"]}</div>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>}
              {/* {visibleItemCount < data.length && ( */}

              {/* {showMore && ( */}
               {/* { myServiceData.length > 0 && !loading && myServiceData.length % 30 === 0 && <Container>
                  <Row className="justify-content-center">
                    <Col xs={12} lg={3}>
                      <PrimaryGradientButton
                        disabled={!showMore}
                        onClick={onLoadMore}
                        buttonText="Show More"
                      />
                    </Col>
                  </Row>
                </Container>} */}
                {myServiceData.length > 0 && myServiceData.length % 30 === 0 && (
                  loading ? (
                    <Container>
                  <Row className="justify-content-center">
                    <Col xs={12} lg={3}>
                      <PrimaryGradientButton
                        buttonText="Loading..."
                      />
                    </Col>
                  </Row>
                </Container>
                  ) : (
                    <Container>
                  <Row className="justify-content-center">
                    <Col xs={12} lg={3}>
                      <PrimaryGradientButton
                        disabled={!showMore}
                        onClick={onLoadMore}
                        buttonText="Show More"
                      />
                    </Col>
                  </Row>
                </Container>
                  )
                )}
              {/* )} */}
            </Col>
          </Row>

          <Col xs={12}>
            <ModalComponent
              onHide={onHide}
              page="myService"
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              serviceRejectReasonData={serviceRejectReasonData}
              serviceAcceptReasonData={serviceAcceptReasonData}
              serviceApproval={currentServiceData}
              outlinebuttonText="I Understood"
              onClick={""}
              modalTitle="Service Approval"
              selectedValue={selectedValue}
              setSelectedValue={setSelectedValue}
              isRejectReasonShow={isRejectReasonShow}
              setIsRejectReasonShow={setIsRejectReasonShow}
              isAcceptReasonShow={isAcceptReasonShow}
              setIsAcceptReasonShow={setIsAcceptReasonShow}
              handleApprove={handleApprove}
              handleRejectReasonOnChange={handleRejectReasonOnChange}
              showAlert={showAlert}
              isLoginSuccessText={isLoginSuccessText}
              isLoginSuccessCondition={isLoginSuccessCondition}
              isLoginSuccessHeading={isLoginSuccessHeading}
            />
          </Col>
        </Container>
      </section>
    </>
  );
};

export default MyService;
